import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, languages } from '../translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage for saved preference
    const saved = localStorage.getItem('language');
    return saved || 'en';
  });

  const [t, setT] = useState(translations[language] || translations.en);

  useEffect(() => {
    // Update translations when language changes
    setT(translations[language] || translations.en);
    // Save to localStorage
    localStorage.setItem('language', language);
    // Update document direction for RTL languages if needed
    document.documentElement.lang = language;
  }, [language]);

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  const value = {
    language,
    setLanguage: changeLanguage,
    t,
    languages,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
